import { render, staticRenderFns } from "./ConfigureAlertsForm.vue?vue&type=template&id=7add9d3d&scoped=true&"
import script from "./ConfigureAlertsForm.vue?vue&type=script&lang=js&"
export * from "./ConfigureAlertsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7add9d3d",
  null
  
)

export default component.exports